import { LmgService } from "../resource";

const BillingModule = {
  namespaced: true,
  state: {
    datas: [],
    billings: {},
    invoice_status: [
        { ID: 0, Name: "All" },
        { ID: 1, Name: "รอชำระเงิน" },
        { ID: 2, Name: "ชำระเงินแล้ว" },
        { ID: 3, Name: "ยกเลิก" }
      ],
  },
  mutations: {
    SET_DATAS(state, payload) {
      state.datas = payload;
    },
    SET_BILLINGS(state, payload) {
      state.billings = payload;
    },
  },
  actions: {
    createData({ commit, state }, payload) {
      return LmgService.InvoiceCreate(payload);
    },
	paidData({ commit, state }, payload) {
			return LmgService.InvoicePaid(payload);
	},	
	reportData({ commit, state }, payload) {
		return LmgService.InvoiceReport(payload);
	},	


    async listData({ commit, state },payload) {
      try {
        const data = await LmgService.InvoiceList(payload);
        if (data.data.Data == null) {
          commit("SET_DATAS", []);
        } else {
          commit("SET_DATAS", data.data.Data);
        }
      } catch (err) {
        commit("SET_DATAS", []);
      }
    },

	async listBilling({ commit, state },payload) {
		try {
		  const data = await LmgService.InvoiceBillingList(payload);
		  if (data.data.Data == null) {
			commit("SET_BILLINGS", []);
		  } else {
			commit("SET_BILLINGS", data.data.Data);
		  }
		} catch (err) {
		  commit("SET_BILLINGS", []);
		}
	  },
	clearBilling({ commit, state },payload) {
		  commit("SET_BILLINGS", []);
	}


  },
  getters: {
    getData(state) {
      return state.datas;
    },
	getBilling(state) {
		return state.billings;
	  },
	getInvoiceStatus(state) {
		return state.invoice_status;
	}
  }
};

export default BillingModule;
